module.exports = __webpack_public_path__ + "static/media/close.abfda85e.svg";